import { render } from "./EditExpenseType.vue?vue&type=template&id=72e9c95e&scoped=true"
import script from "./EditExpenseType.vue?vue&type=script&lang=js"
export * from "./EditExpenseType.vue?vue&type=script&lang=js"

import "../save-expensetype-event.scss?vue&type=style&index=0&id=72e9c95e&lang=scss&scoped=true"

import exportComponent from "/srv/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72e9c95e"]])

export default __exports__